import { Typography, TypographyProps } from '@mui/material';

interface PageTitleProps extends TypographyProps {
  children: React.ReactNode;
}

export const PageTitle = ({ children, ...props }: PageTitleProps) => {
  return (
    <Typography
      variant="h4"
      component="h1"
      gutterBottom
      sx={{ 
        fontSize: { 
          xs: '1.25rem', 
          sm: '1.5rem', 
          md: '1.75rem' 
        },
        ...props.sx 
      }}
      {...props}
    >
      {children}
    </Typography>
  );
}; 